import { render, staticRenderFns } from "./AlterarDadosTecnico.vue?vue&type=template&id=fac0db02&scoped=true"
import script from "./AlterarDadosTecnico.vue?vue&type=script&lang=js"
export * from "./AlterarDadosTecnico.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosTecnico.vue?vue&type=style&index=0&id=fac0db02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac0db02",
  null
  
)

export default component.exports